module.exports = __webpack_public_path__ + "static/media/montemor-5.6b8c7a56.jpg";